import script from "./Upgrade.vue?vue&type=script&setup=true&lang=ts"
export * from "./Upgrade.vue?vue&type=script&setup=true&lang=ts"

import "./Upgrade.vue?vue&type=style&index=0&id=c8a26656&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8a26656"]])

export default __exports__